var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_2558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9456 4.15563C22.2439 2.41791 20.5349 0.541177 17.3342 0.798959C13.2569 1.23872 11.9863 5.11529 12.6024 7.428C10.9785 6.33706 8.21714 5.85731 5.80691 7.90555C2.69501 11.0004 4.35953 15.1858 6.07024 16.1897C4.18483 16.0165 1.2051 17.2805 0.545877 20.5867C-0.155399 24.6917 2.99887 27.0847 6.07024 27.0847H40.1289C43.6805 27.0847 45.6512 24.0365 45.4301 21.1617C45.0816 17.4097 41.6209 15.9701 39.7332 16.2785C41.3104 15.4056 43.4169 11.3048 40.2139 8.081C37.6715 5.68186 34.4303 6.55469 33.2907 7.60117C33.9051 5.59693 32.8977 1.45392 28.7739 0.798565C28.4891 0.766923 28.2146 0.75 27.9531 0.75C24.8051 0.750315 23.3897 3.0332 22.9456 4.15563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37399 8.55921C4.57577 10.1741 3.92131 13.8333 7.16285 15.9724L20.0945 24.7744L13.8243 10.5228C12.5104 7.15979 8.91608 6.42643 6.37399 8.55921Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5057 1.62948C15.4037 1.67191 12.2474 4.15535 13.6521 7.94753L20.1369 23.1209L22.4157 7.16144C22.9431 3.19585 19.9182 1.36524 17.5057 1.62948Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4279 6.55278H24.6541C24.6541 6.55278 25.309 6.55278 25.3981 6.85921C24.9155 7.25017 23.6019 7.29913 23.7763 9.38751L25.8379 23.1188L32.2786 7.90553C33.596 4.50871 30.8306 1.67185 28.3777 1.58511C28.2632 1.57692 28.1481 1.57031 28.0293 1.57031C25.8275 1.57023 23.3044 3.1577 23.4279 6.55278Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0193 10.6518L25.9272 24.7323L38.8553 15.8839C41.8353 13.7868 41.3546 10.4342 39.6865 8.77703C38.9872 7.99707 37.7032 7.39453 36.3429 7.39453C34.736 7.3943 33.0162 8.2399 32.0193 10.6518Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4081 17.8868L25.2671 26.3001H40.2159C43.2829 26.3001 45.2538 23.1627 44.3777 20.2838C43.7909 18.4743 42.0547 17.0538 40.0396 17.0518C39.1914 17.0522 38.2918 17.3056 37.4081 17.8868Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02554 26.3003H20.7538L8.60992 17.887C5.8045 16.0987 2.64975 17.1451 1.51092 20.1127C0.545608 23.5099 2.95584 26.3003 6.02554 26.3003Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3363 37.8116H25.0686C25.6966 37.8508 26.81 38.3949 26.81 39.6833C26.81 41.0309 25.6545 41.5747 25.0284 41.6361H22.3363V37.8116ZM22.2947 31.8121H24.5436C25.3123 31.8533 26.2213 32.4168 26.2213 33.4632C26.2213 34.4895 25.5341 35.1735 24.6449 35.2954H22.2947V31.8121ZM19.22 29.3154V44.1302H26.4655C28.1853 44.1302 30.2296 42.4202 30.2296 40.1857C30.2296 37.8511 28.6922 36.7045 27.7195 36.2412C27.7195 36.2412 29.5006 35.2148 29.4214 33C29.3404 30.0208 26.5663 29.3154 25.6153 29.3154H19.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10722 44.1301V35.5973L17.4985 44.6937V29.3154H14.3428V37.6299L4.94922 28.7129V44.1301H8.10722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7371 36.5625C30.8162 41.2475 34.2092 44.7502 38.5711 44.7502C39.6053 44.7502 40.6949 44.556 41.8084 44.1303V41.1117C40.9259 41.6467 39.9439 41.9047 38.9818 41.9047C36.3422 41.9047 33.8516 39.9668 33.9546 36.4422C34.1325 33.5831 36.4918 31.6088 39.0345 31.6088C39.9656 31.6088 40.9233 31.8749 41.8084 32.4563V29.5186C40.7763 29.1036 39.7505 28.918 38.7623 28.918C34.4114 28.9179 30.8206 32.559 30.7371 36.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_2558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    fill: "white",
    transform: "translate(0.447021 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbc);
export default __webpack_public_path__ + "static/media/nbc.01129f86164d8e7ef5eeca9a56f7defb.svg";
export { ForwardRef as ReactComponent };